var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMypageConsultation = function SvgMypageConsultation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD267",
    d: "M15.938 9.375a6.57 6.57 0 0 0-6.563 6.563 6.57 6.57 0 0 0 6.563 6.562h5.024v-2.35a6.55 6.55 0 0 0 1.538-4.212 6.57 6.57 0 0 0-6.562-6.563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M9.703 1.5c4.523 0 8.204 3.68 8.204 8.204 0 4.522-3.68 8.202-8.204 8.202h-6.28V14.97A8.2 8.2 0 0 1 1.5 9.704C1.5 5.18 5.18 1.5 9.703 1.5"
  })));
};
export default SvgMypageConsultation;